var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"board-cut-line gl-mb-3 gl-flex gl-items-center gl-text-red-700"},[_c('span',{staticClass:"gl-px-2 gl-text-sm gl-font-bold",attrs:{"data-testid":"cut-line-text"}},[_vm._v(_vm._s(_vm.cutLineText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }